import { Icon } from '@iwoca/orion';
import styles from './PhoneNumber.module.css';

export const PhoneNumber = ({ number }: { number: string }) => (
    <a href={`tel:${number}`} className={styles.number}>
        <Icon icon="phoneFilled" className={styles.icon} />
        <span>{number}</span>
    </a>
);
